export enum SettingEnum {
    StartDayOfWeek = 'Start Day Of Week',
    DefaultEmployeeType = 'Default Employee Type',
    DefaultEmail = 'Default Email',
    FinalNotice = 'Final Notice',
    FirstNotice = 'First Notice',
    TimesheetAdmin = 'Timesheet Admin',
    WorkOrderNotesConfig = 'Work Order Notes Configuration',
}
